import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { baseUrlFunc } from '../../app/app.module';
import { HttpInterceptorProvider } from '../http-interceptor/http-interceptor';

/*
  Generated class for the ProductsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ProdutosProvider {
  apiBase = baseUrlFunc() + "wp/v2/produtos?per_page=100"

  constructor(public http: HttpInterceptorProvider) {
    console.log('Hello ProductsProvider Provider');
  }

  requestProducts(): Observable<any> {
    return Observable.create(observer => {
      this.http.get(this.apiBase).subscribe(data => {
        observer.next(data)
      }, err => {
        observer.error(err)
      })
    })
  }

}



// WEBPACK FOOTER //
// ./src/providers/products/products.ts